import {Navigate, Outlet} from 'react-router-dom';

import {useCookies} from 'react-cookie';
import useGetSupplierProfile from '../../services/hookService/getSupplierProfile/useGetSupplierProfile';

const ProtectedRoute = () => {
  useGetSupplierProfile({});
  const [cookies] = useCookies();

  const cookie = cookies?.user;

  const userProfile = window.localStorage.getItem('user');

  if (cookie?.access_token) {
    const userJson = {
      token: cookie?.access_token,
    };

    localStorage.setItem('user', JSON.stringify(userJson));
    return <Outlet />;
  }

  if (
    userProfile &&
    userProfile !== 'null' &&
    'token' in JSON.parse(userProfile) &&
    JSON.parse(userProfile).token
  ) {
    return <Outlet />;
  }
  return <Navigate to="/auth/login" />;
};

export default ProtectedRoute;
